<!-- ════════════ NAVBAR ════════════ -->
<nav class="unav">
  <div class="container-fluid">
    <a class="unav-brand" routerLink="/">
      <img src="assetses/img/logo.png" alt="UMYOBizDFW">
      <span>UMYO<em>BizDFW</em></span>
    </a>
    <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
    <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
      <li><a href="/">Home</a></li>
      <li><a href="/about">About Us</a></li>
      <li><a routerLink="/networks">Network</a></li>
      <li><a routerLink="/hub">Hub</a></li>
      <li><a routerLink="/anti-bullying">Anti-Bullying</a></li>
      <li><a routerLink="/community-impact" >Community Fund</a></li>
      <li><a routerLink="/empower-youth" class="active">Empower Youth</a></li>
      <li><a routerLink="/services">Type of Servcies</a></li>
      <li><a routerLink="/cf">Card Features</a></li>
    </ul>
    <!-- <a href="/#registration-form" class="unav-cta" >Join $2.54/mo</a> -->
  </div>
</nav>

<!-- ════════ HERO ════════ -->
<section class="uhero">
  <div class="cg"></div>
  <div class="orb orb1"></div>
  <div class="orb orb2"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="row align-items-center gy-5">
      <div class="col-lg-7">
        <p class="hero-ey">DFW Anti-Bullying & Self-Defense Community Movement</p>
        <h1 class="hero-t">Empower<br><span class="ac">10K Youth</span></h1>
        <p class="hero-sub">The Dallas–Fort Worth region is home to over 8.3 million residents and approximately 350,000 businesses — creating a powerful opportunity for unified community impact. Together, we fund professional self-defense training for students affected by bullying.</p>
        <div class="hero-btns">
          <a href="/#registration-form" class="btn-c">👉 Join the Movement</a>
          <a href="/empower-youth#calculator" class="btn-o">See the Numbers</a>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-flex justify-content-center">
        <div style="position:relative;">
          <div style="width:300px;height:300px;border-radius:50%;border:1px solid rgba(0,212,255,.12);display:flex;align-items:center;justify-content:center;position:relative;">
            <div style="position:absolute;inset:-2px;border-radius:50%;border:2px solid transparent;border-top-color:var(--cc);border-right-color:rgba(0,212,255,.3);animation:spin 5s linear infinite;"></div>
            <div style="width:240px;height:240px;border-radius:50%;background:radial-gradient(circle,rgba(0,87,255,.15),transparent 70%);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.5rem;overflow:hidden;">
              <img src="assetses/img/Kennedy-Nzechukwu.png" alt="Kennedy Nzechukwu"
                   style="width:100%;height:100%;object-fit:cover;object-position:top;border-radius:50%;">
            </div>
            <span style="position:absolute;top:20px;right:0;background:rgba(0,212,255,.1);border:1px solid rgba(0,212,255,.25);border-radius:50px;padding:.35rem .9rem;font-size:.72rem;font-weight:600;color:var(--ccl);letter-spacing:.08em;">10,000 Students</span>
            <span style="position:absolute;bottom:30px;right:-10px;background:rgba(0,212,255,.1);border:1px solid rgba(0,212,255,.25);border-radius:50px;padding:.35rem .9rem;font-size:.72rem;font-weight:600;color:var(--ccl);letter-spacing:.08em;">8.3M DFW</span>
            <span style="position:absolute;bottom:20px;left:0;background:rgba(0,212,255,.1);border:1px solid rgba(0,212,255,.25);border-radius:50px;padding:.35rem .9rem;font-size:.72rem;font-weight:600;color:var(--ccl);letter-spacing:.08em;">UFC Backed</span>
          </div>
          <p style="font-size:.72rem;color:var(--cm);letter-spacing:.1em;text-transform:uppercase;text-align:center;margin-top:1rem;">Kennedy Nzechukwu · UFC Fighter</p>
        </div>
      </div>
    </div>
  </div>
  <div class="scr"><span>See the impact</span><div class="scl"></div></div>
</section>

<!-- ════════ STATS STRIP ════════ -->
<div class="umstrip " sipScrollReveal [sipDelay]="0">
  <div class="container">
    <div><div class="ums-n">8.3M</div><div class="ums-l">DFW Residents</div></div>
    <div><div class="ums-n">350K</div><div class="ums-l">DFW Businesses</div></div>
    <div><div class="ums-n">10,000</div><div class="ums-l">Youth Goal</div></div>
    <div><div class="ums-n">$2.54</div><div class="ums-l">Starting/Month</div></div>
    <div><div class="ums-n">40,910</div><div class="ums-l">Members @ $109.99</div></div>
  </div>
</div>

<!-- ════════ ABOUT MOVEMENT ════════ -->
<section class="usec">
  <div class="cg"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="row g-5 align-items-center">
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0">
        <span class="lbl">DFW United</span>
        <h2 class="hd2">Anti-Bullying &<br><span class="ac">Self-Defense</span><br>Movement</h2>
        <div class="dv"></div>
        <p class="tx mb-3">This initiative mobilizes residents through a digital membership platform that <strong style="color:var(--cw);">directly funds professional self-defense training</strong> for students affected by bullying.</p>
        <p class="tx mb-3">Participants receive structured instruction from certified MMA trainers focused on confidence building, discipline, situational awareness, and mental resilience.</p>
        <p class="tx">This initiative addresses bullying at its root by combining <strong style="color:var(--cw);">prevention, empowerment, and measurable community involvement.</strong></p>
      </div>
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0.08">
        <div style="background:rgba(0,212,255,.04);border:1px solid var(--bd);border-radius:14px;padding:2rem;">
          <span class="lbl">By Joining DFW's First Digital City, We Collectively Invest In:</span>
          <div class="fund-pill"><span style="font-size:1.1rem;">🛡️</span> Youth Protection</div>
          <div class="fund-pill"><span style="font-size:1.1rem;">🧠</span> Mental Health Support</div>
          <div class="fund-pill"><span style="font-size:1.1rem;">🚫</span> Violence Prevention</div>
          <div class="fund-pill"><span style="font-size:1.1rem;">🤝</span> Community Accountability</div>
          <div style="margin-top:1.5rem;padding:1.2rem 1.5rem;border-left:3px solid var(--cc);background:rgba(0,212,255,.04);border-radius:0 10px 10px 0;">
            <p style="font-style:italic;color:var(--cw);font-size:.95rem;line-height:1.8;margin:0;">"Together, we can position Dallas–Fort Worth as a national model for proactive, community-driven student safety."</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════ CALCULATOR ════════ -->
<section class="usec usec-alt" id="calculator">
  <div class="container">
    <div class="text-center mb-5" sipScrollReveal [sipDelay]="0">
      <span class="lbl">Impact Calculator</span>
      <h2 class="hd2">How Many Members<br><span class="ac">Fund How Many Students?</span></h2>
      <div class="dv mx-auto"></div>
      <p class="tx mx-auto" style="max-width:600px;">Select a membership tier to see exactly how many DFW residents are needed to fund students at that price point. The math is clear — and powerful.</p>
    </div>

    <!-- Price Tabs -->
    <div class="ptabs  justify-content-center d-flex" sipScrollReveal [sipDelay]="0.08">
      <button class="ptab"
        [class.active]="activeTab === 'p254'"
        (click)="showPanel('p254')">$2.54
      </button>
      <button class="ptab"
        [class.active]="activeTab === 'p599'"
        (click)="showPanel('p599')">$5.99
      </button>
      <button class="ptab"
        [class.active]="activeTab === 'p999'"
        (click)="showPanel('p999')">$9.99
      </button>
      <button class="ptab"
        [class.active]="activeTab === 'p1999'"
        (click)="showPanel('p1999')">$19.99
      </button>
      <button class="ptab"
        [class.active]="activeTab === 'p4999'"
        (click)="showPanel('p4999')">$49.99
      </button>
      <button class="ptab"
        [class.active]="activeTab === 'p7999'"
        (click)="showPanel('p7999')">$79.99
      </button>
      <button class="ptab"
        [class.active]="activeTab === 'p10999'"
        (click)="showPanel('p10999')">$109.99
      </button>
    </div>

    <!-- $2.54 -->
    <div class="tpanel active " [class.active]="activeTab === 'p254'" sipScrollReveal [sipDelay]="0.08" id="p254">
      <div class="tcard">
        <div class="tcard-head">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="price-big">$2.54</div>
              <div class="price-sub">per member / per month</div>
            </div>
            <div class="col-md-8">
              <p style="color:var(--cm);font-size:.9rem;margin:0;">At this entry-level price, reaching 10,000 funded students requires <strong style="color:var(--ccl);">1,771,260 members</strong> — but DFW has 8.3 million residents. The scale is achievable.</p>
            </div>
          </div>
        </div>
        <div style="padding:1.5rem;">
          <table class="imp-table">
            <thead><tr><th>Students Funded</th><th>Members Needed</th><th>% of DFW (8.3M)</th></tr></thead>
            <tbody>
              <tr><td class="td-stu">1</td><td class="td-mem">178</td><td style="color:var(--cm);">0.002%</td></tr>
              <tr><td class="td-stu">50</td><td class="td-mem">8,856</td><td style="color:var(--cm);">0.1%</td></tr>
              <tr><td class="td-stu">100</td><td class="td-mem">17,713</td><td style="color:var(--cm);">0.21%</td></tr>
              <tr><td class="td-stu">500</td><td class="td-mem">88,563</td><td style="color:var(--cm);">1.07%</td></tr>
              <tr><td class="td-stu">1,000</td><td class="td-mem">177,126</td><td style="color:var(--cm);">2.13%</td></tr>
              <tr><td class="td-stu">5,000</td><td class="td-mem">885,630</td><td style="color:var(--cm);">10.67%</td></tr>
              <tr class="highlight"><td class="td-stu">10,000</td><td class="td-mem">1,771,260</td><td style="color:var(--ccl);font-weight:600;">21.34%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- $5.99 -->
    <div class="tpanel " sipScrollReveal [sipDelay]="0.08" [class.active]="activeTab === 'p599'" id="p599">
      <div class="tcard">
        <div class="tcard-head">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="price-big">$5.99</div>
              <div class="price-sub">per member / per month</div>
            </div>
            <div class="col-md-8">
              <p style="color:var(--cm);font-size:.9rem;margin:0;">At $5.99, funding 10,000 students requires <strong style="color:var(--ccl);">750,918 members</strong> — just 9% of DFW's population. This tier cuts the scale requirement in half.</p>
            </div>
          </div>
        </div>
        <div style="padding:1.5rem;">
          <table class="imp-table">
            <thead><tr><th>Students Funded</th><th>Members Needed</th><th>% of DFW (8.3M)</th></tr></thead>
            <tbody>
              <tr><td class="td-stu">1</td><td class="td-mem">76</td><td style="color:var(--cm);">0.001%</td></tr>
              <tr><td class="td-stu">50</td><td class="td-mem">3,756</td><td style="color:var(--cm);">0.045%</td></tr>
              <tr><td class="td-stu">100</td><td class="td-mem">7,511</td><td style="color:var(--cm);">0.09%</td></tr>
              <tr><td class="td-stu">500</td><td class="td-mem">37,555</td><td style="color:var(--cm);">0.45%</td></tr>
              <tr><td class="td-stu">1,000</td><td class="td-mem">75,109</td><td style="color:var(--cm);">0.91%</td></tr>
              <tr><td class="td-stu">5,000</td><td class="td-mem">375,459</td><td style="color:var(--cm);">4.52%</td></tr>
              <tr class="highlight"><td class="td-stu">10,000</td><td class="td-mem">750,918</td><td style="color:var(--ccl);font-weight:600;">9.05%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- $9.99 -->
    <div class="tpanel" sipScrollReveal [sipDelay]="0.08" [class.active]="activeTab === 'p999'" id="p999">
      <div class="tcard">
        <div class="tcard-head">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="price-big">$9.99</div>
              <div class="price-sub">per member / per month</div>
            </div>
            <div class="col-md-8">
              <p style="color:var(--cm);font-size:.9rem;margin:0;">At $9.99, just <strong style="color:var(--ccl);">450,451 members</strong> — 5.4% of DFW — fund 10,000 students monthly with professional training.</p>
            </div>
          </div>
        </div>
        <div style="padding:1.5rem;">
          <table class="imp-table">
            <thead><tr><th>Students Funded</th><th>Members Needed</th><th>% of DFW (8.3M)</th></tr></thead>
            <tbody>
              <tr><td class="td-stu">1</td><td class="td-mem">46</td><td style="color:var(--cm);">0.001%</td></tr>
              <tr><td class="td-stu">50</td><td class="td-mem">2,252</td><td style="color:var(--cm);">0.027%</td></tr>
              <tr><td class="td-stu">100</td><td class="td-mem">4,504</td><td style="color:var(--cm);">0.054%</td></tr>
              <tr><td class="td-stu">500</td><td class="td-mem">22,518</td><td style="color:var(--cm);">0.27%</td></tr>
              <tr><td class="td-stu">1,000</td><td class="td-mem">45,036</td><td style="color:var(--cm);">0.54%</td></tr>
              <tr><td class="td-stu">5,000</td><td class="td-mem">225,226</td><td style="color:var(--cm);">2.71%</td></tr>
              <tr class="highlight"><td class="td-stu">10,000</td><td class="td-mem">450,451</td><td style="color:var(--ccl);font-weight:600;">5.43%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- $19.99 -->
    <div class="tpanel " sipScrollReveal [sipDelay]="0.08" [class.active]="activeTab === 'p1999'" id="p1999">
      <div class="tcard">
        <div class="tcard-head">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="price-big">$19.99</div>
              <div class="price-sub">per member / per month</div>
            </div>
            <div class="col-md-8">
              <p style="color:var(--cm);font-size:.9rem;margin:0;">At $19.99, only <strong style="color:var(--ccl);">225,063 members</strong> — just 2.7% of DFW — are needed to protect 10,000 students every month.</p>
            </div>
          </div>
        </div>
        <div style="padding:1.5rem;">
          <table class="imp-table">
            <thead><tr><th>Students Funded</th><th>Members Needed</th><th>% of DFW (8.3M)</th></tr></thead>
            <tbody>
              <tr><td class="td-stu">1</td><td class="td-mem">23</td><td style="color:var(--cm);">0.0003%</td></tr>
              <tr><td class="td-stu">50</td><td class="td-mem">1,125</td><td style="color:var(--cm);">0.014%</td></tr>
              <tr><td class="td-stu">100</td><td class="td-mem">2,250</td><td style="color:var(--cm);">0.027%</td></tr>
              <tr><td class="td-stu">500</td><td class="td-mem">11,254</td><td style="color:var(--cm);">0.14%</td></tr>
              <tr><td class="td-stu">1,000</td><td class="td-mem">22,507</td><td style="color:var(--cm);">0.27%</td></tr>
              <tr><td class="td-stu">5,000</td><td class="td-mem">112,531</td><td style="color:var(--cm);">1.36%</td></tr>
              <tr class="highlight"><td class="td-stu">10,000</td><td class="td-mem">225,063</td><td style="color:var(--ccl);font-weight:600;">2.71%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- $49.99 -->
    <div class="tpanel " sipScrollReveal [sipDelay]="0.08"  [class.active]="activeTab === 'p4999'" id="p4999">
      <div class="tcard">
        <div class="tcard-head">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="price-big">$49.99</div>
              <div class="price-sub">per member / per month</div>
            </div>
            <div class="col-md-8">
              <p style="color:var(--cm);font-size:.9rem;margin:0;">At $49.99, just <strong style="color:var(--ccl);">90,000 members</strong> — barely 1% of DFW — fund 10,000 students. Businesses at this tier move the needle fast.</p>
            </div>
          </div>
        </div>
        <div style="padding:1.5rem;">
          <table class="imp-table">
            <thead><tr><th>Students Funded</th><th>Members Needed</th><th>% of DFW (8.3M)</th></tr></thead>
            <tbody>
              <tr><td class="td-stu">1</td><td class="td-mem">9</td><td style="color:var(--cm);">0.0001%</td></tr>
              <tr><td class="td-stu">50</td><td class="td-mem">450</td><td style="color:var(--cm);">0.005%</td></tr>
              <tr><td class="td-stu">100</td><td class="td-mem">900</td><td style="color:var(--cm);">0.011%</td></tr>
              <tr><td class="td-stu">500</td><td class="td-mem">4,500</td><td style="color:var(--cm);">0.054%</td></tr>
              <tr><td class="td-stu">1,000</td><td class="td-mem">9,000</td><td style="color:var(--cm);">0.11%</td></tr>
              <tr><td class="td-stu">5,000</td><td class="td-mem">45,000</td><td style="color:var(--cm);">0.54%</td></tr>
              <tr class="highlight"><td class="td-stu">10,000</td><td class="td-mem">90,000</td><td style="color:var(--ccl);font-weight:600;">1.08%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- $79.99 -->
    <div class="tpanel" sipScrollReveal [sipDelay]="0.08" [class.active]="activeTab === 'p7999'" id="p7999">
      <div class="tcard">
        <div class="tcard-head">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="price-big">$79.99</div>
              <div class="price-sub">per member / per month</div>
            </div>
            <div class="col-md-8">
              <p style="color:var(--cm);font-size:.9rem;margin:0;">At $79.99, only <strong style="color:var(--ccl);">56,251 members</strong> are needed — less than 0.7% of DFW's population to fully fund 10,000 student programs.</p>
            </div>
          </div>
        </div>
        <div style="padding:1.5rem;">
          <table class="imp-table">
            <thead><tr><th>Students Funded</th><th>Members Needed</th><th>% of DFW (8.3M)</th></tr></thead>
            <tbody>
              <tr><td class="td-stu">1</td><td class="td-mem">6</td><td style="color:var(--cm);">0.00007%</td></tr>
              <tr><td class="td-stu">50</td><td class="td-mem">282</td><td style="color:var(--cm);">0.003%</td></tr>
              <tr><td class="td-stu">100</td><td class="td-mem">563</td><td style="color:var(--cm);">0.007%</td></tr>
              <tr><td class="td-stu">500</td><td class="td-mem">2,813</td><td style="color:var(--cm);">0.034%</td></tr>
              <tr><td class="td-stu">1,000</td><td class="td-mem">5,626</td><td style="color:var(--cm);">0.068%</td></tr>
              <tr><td class="td-stu">5,000</td><td class="td-mem">28,125</td><td style="color:var(--cm);">0.34%</td></tr>
              <tr class="highlight"><td class="td-stu">10,000</td><td class="td-mem">56,251</td><td style="color:var(--ccl);font-weight:600;">0.68%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- $109.99 -->
    <div class="tpanel" sipScrollReveal [sipDelay]="0.08" [class.active]="activeTab === 'p10999'" id="p10999">
      <div class="tcard">
        <div class="tcard-head">
          <div class="row align-items-center">
            <div class="col-md-4">
              <div class="price-big">$109.99</div>
              <div class="price-sub">per member / per month</div>
            </div>
            <div class="col-md-8">
              <p style="color:var(--cm);font-size:.9rem;margin:0;">At $109.99, only <strong style="color:var(--ccl);">40,910 members</strong> — just 0.49% of DFW — are needed to protect 10,000 students monthly. The most efficient path to scale.</p>
            </div>
          </div>
        </div>
        <div style="padding:1.5rem;">
          <table class="imp-table">
            <thead><tr><th>Students Funded</th><th>Members Needed</th><th>% of DFW (8.3M)</th></tr></thead>
            <tbody>
              <tr><td class="td-stu">1</td><td class="td-mem">5</td><td style="color:var(--cm);">0.00006%</td></tr>
              <tr><td class="td-stu">50</td><td class="td-mem">205</td><td style="color:var(--cm);">0.0025%</td></tr>
              <tr><td class="td-stu">100</td><td class="td-mem">410</td><td style="color:var(--cm);">0.005%</td></tr>
              <tr><td class="td-stu">500</td><td class="td-mem">2,046</td><td style="color:var(--cm);">0.025%</td></tr>
              <tr><td class="td-stu">1,000</td><td class="td-mem">4,091</td><td style="color:var(--cm);">0.049%</td></tr>
              <tr><td class="td-stu">5,000</td><td class="td-mem">20,455</td><td style="color:var(--cm);">0.25%</td></tr>
              <tr class="highlight"><td class="td-stu">10,000</td><td class="td-mem">40,910</td><td style="color:var(--ccl);font-weight:600;">0.49%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════ PERSPECTIVE ════════ -->
<section class="usec">
  <div class="cg"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="text-center mb-5 " sipScrollReveal [sipDelay]="0">
      <span class="lbl">🔥 Perspective</span>
      <h2 class="hd2">To Fund <span class="ac">10,000 Students</span><br>Monthly</h2>
      <div class="dv mx-auto"></div>
      <p class="tx mx-auto" style="max-width:580px;">The difference in scale between price tiers is massive. At the highest tier, less than 0.5% of DFW makes the entire goal possible.</p>
    </div>

    <!-- Progress bars comparison -->
    <div class="row g-4">
      <div class="col-lg-6" sipScrollReveal [sipDelay]="0.08">
        <div style="background:rgba(0,212,255,.03);border:1px solid var(--bd);border-radius:14px;padding:2rem;">
          <span class="lbl">Members Needed — 10K Students</span>
          <div class="prog-wrap">
            <div class="prog-label"><span>$2.54/mo</span><span style="color:var(--ccl);">1,771,260 members</span></div>
            <div class="prog-bar"><div class="prog-fill" style="width:100%;"></div></div>
          </div>
          <div class="prog-wrap">
            <div class="prog-label"><span>$5.99/mo</span><span style="color:var(--ccl);">750,918 members</span></div>
            <div class="prog-bar"><div class="prog-fill" style="width:42%;"></div></div>
          </div>
          <div class="prog-wrap">
            <div class="prog-label"><span>$9.99/mo</span><span style="color:var(--ccl);">450,451 members</span></div>
            <div class="prog-bar"><div class="prog-fill" style="width:25%;"></div></div>
          </div>
          <div class="prog-wrap">
            <div class="prog-label"><span>$19.99/mo</span><span style="color:var(--ccl);">225,063 members</span></div>
            <div class="prog-bar"><div class="prog-fill" style="width:13%;"></div></div>
          </div>
          <div class="prog-wrap">
            <div class="prog-label"><span>$49.99/mo</span><span style="color:var(--ccl);">90,000 members</span></div>
            <div class="prog-bar"><div class="prog-fill" style="width:5%;"></div></div>
          </div>
          <div class="prog-wrap">
            <div class="prog-label"><span>$79.99/mo</span><span style="color:var(--ccl);">56,251 members</span></div>
            <div class="prog-bar"><div class="prog-fill" style="width:3.2%;"></div></div>
          </div>
          <div class="prog-wrap">
            <div class="prog-label"><span>$109.99/mo</span><span style="color:var(--ccl);">40,910 members</span></div>
            <div class="prog-bar"><div class="prog-fill" style="width:2.3%;"></div></div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="row g-3">
          <div class="col-6 " sipScrollReveal [sipDelay]="0">
            <div class="uc persp-card">
              <div class="persp-num">21.3%</div>
              <div class="persp-label">of DFW at $2.54 needed</div>
            </div>
          </div>
          <div class="col-6 " sipScrollReveal [sipDelay]="0.08">
            <div class="uc persp-card">
              <div class="persp-num">9%</div>
              <div class="persp-label">of DFW at $5.99 needed</div>
            </div>
          </div>
          <div class="col-6 " sipScrollReveal [sipDelay]="0.24">
            <div class="uc persp-card">
              <div class="persp-num">1.08%</div>
              <div class="persp-label">of DFW at $49.99 needed</div>
            </div>
          </div>
          <div class="col-6" sipScrollReveal [sipDelay]="0.32">
            <div class="uc persp-card" style="border-color:rgba(0,212,255,.3);background:rgba(0,212,255,.06);">
              <div class="persp-num" style="font-size:clamp(1.5rem,3vw,2.5rem);">0.49%</div>
              <div class="persp-label">of DFW at $109.99 needed</div>
            </div>
          </div>
          <div class="col-12 " sipScrollReveal [sipDelay]="0.4">
            <div style="background:linear-gradient(135deg,rgba(0,212,255,.07),rgba(0,87,255,.05));border:1px solid rgba(0,212,255,.2);border-radius:14px;padding:1.8rem;text-align:center;">
              <div style="font-family:var(--fh);font-size:clamp(1.2rem,3vw,2rem);color:var(--cc);text-shadow:0 0 20px rgba(0,212,255,.4);">Massive Difference in Scale</div>
              <p style="font-size:.88rem;color:var(--cm);margin:.8rem 0 0;line-height:1.75;">At $2.54 you need 1.77M members. At $109.99, just 40,910. DFW has 8.3 million residents — this goal is achievable at every tier.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════ FINAL CTA ════════ -->
<section class="ucta">
  <div class="uctag"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="" sipScrollReveal [sipDelay]="0">
      <span class="lbl d-block text-center mb-3">Join the Movement Today</span>
      <h2>Empower 10,000<br><span>DFW Students.</span></h2>
      <p class="tx mx-auto mt-4 mb-4" style="max-width:560px;font-size:1rem;">
        Choose your tier. Join the platform. Every membership directly funds professional self-defense training, confidence building, and mental resilience for students across Dallas–Fort Worth.
      </p>
      <div class="d-flex flex-wrap gap-3 justify-content-center">
        <a href="../#registration-form" class="btn-c">👉 Join Now</a>
        <a href="/anti-bullying/" class="btn-o">Learn About the Movement</a>
      </div>
      <p style="margin-top:1.5rem;font-size:.82rem;color:var(--cm);">Starting at just <strong style="color:var(--ccl);">$2.54/month</strong> · Membership starts today</p>
    </div>
  </div>
</section>

<!-- ════════ FOOTER ════════ -->
<footer class="ufoot">
  <div class="container">
    <img src="assetses/img/logo.png" alt="UMYOBizDFW" onerror="this.style.display='none'">
    <div class="ufb">UMYOBizDFW</div>
    <p>DFW's First Privacy-Gated Digital Community</p>
    <div class="d-flex justify-content-center gap-4 flex-wrap">
      <a href="/">Home</a>
      <a href="/about">About Us</a>
      <a routerLink="/networks">Network</a>
      <a routerLink="/hub">Hub</a>
      <a routerLink="/anti-bullying">Anti-Bullying</a>
      <a routerLink="/community-impact">Community Fund</a>
      <a routerLink="/empower-youth">Empower Youth</a>
      <a routerLink="/services">Type of Servcies</a>
      <a routerLink="/cf">Card Features</a>
      <a href="/terms">Terms &amp; Conditions</a>
    </div>
    <p class="ufc2">© 2025 UMYOBizDFW · Built by the community, for the community</p>
  </div>
</footer>